import React, { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import formateNumber from 'shared/helpers/formateNumber';

import FilterBlock from './FilterBlock';
import ProfileBlock from './ProfileBlock';

import Table from 'components/TableWithPagination/desktop/Table/Table';
import Spinner from 'components/Spinner/desktop';

import './MyDebtAccount.scss';

const b = block('my-debt-account');

const MyDebtAccount = () => {
  const locale = useSelector(state => state.locale.locale);
  const actionProcessing = useSelector(state => state.finance.actionProcessing);
  const financeHistory = useSelector(state => state.finance.financeHistory, shallowEqual);

  const [count, setCount] = useState(10);
  const [page, setPage] = useState(0);

  const onItemsOnPageChanged = newItemsOnPage => {
    setCount(newItemsOnPage);
    setPage(0);
  };

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <ProfileBlock />
      <div className={b('header')}>{locale.myOperations}</div>
      <FilterBlock count={count} currentPage={page} onPageClick={setPage} />
      <div className={b('total-header')}>{locale.balanceActual}</div>
      <div className={b('totals')}>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.totalDeposit}</div>
          <div className={b('totals-data')}>{formateNumber(financeHistory.details.totalDeposit)}</div>
        </div>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.totalWithdrawal}</div>
          <div className={b('totals-data')}>{formateNumber(financeHistory.details.totalWithdraw)}</div>
        </div>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.balance}</div>
          <div className={b('totals-data')}>{formateNumber(financeHistory.details.deltaBalance)}</div>
        </div>
        <div className={b('totals-item')}>
          <div className={b('totals-head')}>{locale.myCommissionBalance}</div>
          <div className={b('totals-data')}>{formateNumber(financeHistory.details.commissionBalance)}</div>
        </div>
      </div>
      <Table
        currentPage={page}
        onPageClick={setPage}
        onItemsOnPageChanged={onItemsOnPageChanged}
        thTdItems={financeHistory.transfers}
        totalCount={financeHistory.details.totalCount}
      />
    </div>
  );
};

export default MyDebtAccount;
